import { get } from 'lodash'

import { DateFields } from '@sigma-frontend-libs/commons'
import { OrderDirections } from '@sigmasms/shared-types'

import { datePresets, getStorageURL, serviceTemplate, services, toFloatOrUndefined } from '@/utils'

export default {
  mixins: [
    serviceTemplate({
      serviceName: services.invoices,

      backendGeneration: 'nest',

      outputFilter(result) {
        result.amount = toFloatOrUndefined(result.amount)

        return result
      },

      find: {
        defaultFilter: {
          scopes: [ 'full' ],
          order: [ [ DateFields.createdAt, OrderDirections.DESC ] ],
          status: undefined,
          docNumber: undefined,
          ownerId: undefined,
          customerId: undefined,
          requisiteId: undefined,
          companyId: undefined,
          createdAtPreset: datePresets.current.month,
          createdAt: {
            gte: undefined,
            lt: undefined
          }
        },
        defaultPagination: {
          limit: 15
        }
      },
      get: {
        params: {
          query: {
            scopes: [ 'full' ]
          }
        }
      },
      create: {
        redirect: true,
        params: {
          query: {
            scopes: [ 'awaitDocument' ]
          }
        },
        after(data) {
          window.location.href = getStorageURL([ get(data, 'Owner.id', data.OwnerId), data.documentId ])
        }
      },
      update: false,

      has: {
        clone: false,
        search: false,
        support: false
      },

      titlePath: 'docNumber',
      formClass: ''
    })
  ]
}
